module.exports = __webpack_public_path__ + "static/media/pr_details3.c2792828.jpg";